module.exports = function getResource(label, vars = []) {
    let resources = {
        item: 'ARTICLE',
        items: 'articles',
        qty: 'QTÉ',
        basketTotal: 'Total du panier',
        subTotal: 'Sous-total',
        checkout: 'Passer à la caisse',
        continue: 'Continuer à magasiner',
        seeSamples: 'Voir les échantillons, récompenses et promotions dans le',
        basket: 'panier',
        title: 'Ajouté au panier',
        reserveTitle: `Ajouté au panier pour ramassage au ${vars[0]}`,
        proceedToBasket: 'Passer au panier',
        viewInBasket: 'Voir dans le panier',
        viewAndCheckout: 'Voir le panier et passer à la caisse',
        viewAndReserve: 'Voir le panier et réserver',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testSeeDetails: 'Voir les détails'
    };

    return resources[label];
};
